import backend from '../backend/backend'
import { DataActions } from './dataReducer'

/** Load one resource into the store under `key`. Resolves with the value (or undefined on failure). */
export const loadResource = (key, fetcher) => async (dispatch) => {
  dispatch({ type: DataActions.LOADING, key })
  try {
    const value = await fetcher()
    dispatch({ type: DataActions.LOADED, key, value })
    return value
  } catch (err) {
    dispatch({ type: DataActions.FAILED, key, error: err })
    return undefined
  }
}

export const keys = {
  customers: (q, page) => `customers:${q || ''}:${page || 1}`,
  customer: (id) => `customer:${id}`,
  applications: (status) => `applications:${status || 'all'}`,
  application: (id) => `application:${id}`,
  loans: (status) => `loans:${status || 'all'}`,
  loan: (id) => `loan:${id}`,
  payments: (status) => `payments:${status || 'all'}`,
  due: 'due',
  overdue: 'overdue',
  products: 'products',
  adminProducts: 'adminProducts',
  agentDashboard: 'dashboard:agent',
  adminDashboard: 'dashboard:admin',
  agents: 'agents',
  audit: (q) => `audit:${JSON.stringify(q || {})}`,
  settings: 'settings',
  report: (name, p) => `report:${name}:${JSON.stringify(p || {})}`,
  receipt: (id) => `receipt:${id}`,
  agreement: (id) => `agreement:${id}`,
}

export const loadCustomers = (q, page) => loadResource(keys.customers(q, page), () => backend.listCustomers({ q, page }))
export const loadCustomer = (id) => loadResource(keys.customer(id), () => backend.getCustomer(id))
export const loadApplications = (status) => loadResource(keys.applications(status), () => backend.listApplications({ status }))
export const loadApplication = (id) => loadResource(keys.application(id), () => backend.getApplication(id))
export const loadLoans = (status) => loadResource(keys.loans(status), () => backend.listLoans({ status }))
export const loadLoan = (id) => loadResource(keys.loan(id), () => backend.getLoan(id))
export const loadPayments = (status) => loadResource(keys.payments(status), () => backend.listPayments({ status }))
export const loadDue = () => loadResource(keys.due, () => backend.listDue())
export const loadOverdue = () => loadResource(keys.overdue, () => backend.listOverdue())
export const loadProducts = () => loadResource(keys.products, () => backend.listProducts())
export const loadAdminProducts = () => loadResource(keys.adminProducts, () => backend.listAdminProducts())
export const loadAgentDashboard = () => loadResource(keys.agentDashboard, () => backend.getAgentDashboard())
export const loadAdminDashboard = () => loadResource(keys.adminDashboard, () => backend.getAdminDashboard())
export const loadAgents = () => loadResource(keys.agents, () => backend.listAgents())
export const loadAudit = (q) => loadResource(keys.audit(q), () => backend.listAudit(q))
export const loadSettings = () => loadResource(keys.settings, () => backend.getSettings())
export const loadReport = (name, p) => loadResource(keys.report(name, p), () => backend.getReport(name, p))
export const loadReceipt = (id) => loadResource(keys.receipt(id), () => backend.getReceipt(id))
export const loadAgreement = (id) => loadResource(keys.agreement(id), () => backend.getAgreement(id))
